import strategyActionTypes from '../types/strategyActionTypes ';
import languageActionTypes from '../types/languageActionTypes';
import translationService from "./../../services/translator.service";

const initialState = {
    strategies: [],
    selectedStrategyId: 0,
    stateInfo: {
        isLoading: false,
        isSuccess: false,
        isError: false,
        error: null
    }
};

const strategyReducer = (state = initialState, action) => {
    switch (action.type) {
        case languageActionTypes.SET_CURRENT_LANGUAGE_SUCCESS:
            return {
                ...state,
                strategies: updateFirstStrategyTranslation(state.strategies, action.payload)
            };
        case strategyActionTypes.START_ADD_STRATEGY:
        case strategyActionTypes.START_DELETE_STRATEGY:
        case strategyActionTypes.START_UPDATE_STRATEGY:
            return {
                ...state,
                stateInfo: {
                    ...state.stateInfo,
                    isLoading: true,
                    isSuccess: false,
                    isError: false,
                    error: null
                }
            };
        case strategyActionTypes.ADD_STRATEGY_SUCCESS:
        case strategyActionTypes.UPDATE_STRATEGY_SUCCESS:
        case strategyActionTypes.DELETE_STRATEGY_SUCCESS:
            return {
                ...state,
                stateInfo: {
                    ...state.stateInfo,
                    isLoading: false,
                    isSuccess: true,
                    isError: false
                }
            };
        case strategyActionTypes.GET_STRATEGY_SUCCESS:
            const firstStrategy = state.strategies[0];
            return {
                ...state,
                strategies: firstStrategy ? [firstStrategy, ...action.payload] : action.payload
            };
        case strategyActionTypes.SELECT_STRATEGY:
            return {
                ...state,
                selectedStrategy: action.payload
            };
        case strategyActionTypes.ADD_STRATEGY_FAILURE:
        case strategyActionTypes.UPDATE_STRATEGY_FAILURE:
        case strategyActionTypes.DELETE_STRATEGY_FAILURE:
            return {
                ...state,
                stateInfo: {
                    ...state.stateInfo,
                    isLoading: false,
                    isSuccess: false,
                    isError: true,
                    error: action.payload
                }
            };
        case strategyActionTypes.RESET_STATE_INFO:
            return {
                ...state,
                stateInfo: initialState.stateInfo
            };
        case "LOGOUT":
            return initialState;
        default:
            return state;
    }
};

const updateFirstStrategyTranslation = (strategies, language) => {
    const transletedData = translationService.getTranslatedData(language, 'general')
    const translatedStrategy = {
        strategyId: 0,
        strategyName: translationService.getTranslation(transletedData, 'general.labels.chooseChargingStrategy')
    };

    if (strategies.length === 0) {
        return [translatedStrategy];
    }

    return [translatedStrategy, ...strategies.slice(1)];
};

export default strategyReducer;
